<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-08 20:14:35
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-12 09:33:43
 * @Description: 动态内容
 -->

<template>
  <div class="news-content-wrapper">
    <h3 class="title">{{ title }}</h3>
    <div class="htmlbody" v-html="htmlBody" ref="htmlbody"></div>
  </div>
</template>
<script>
export default {
  name: 'news-content-wrapper',
  data() {
    return {
      htmlBody: '',
      title: ''
    };
  },
  created() {
    this.requestContent();
  },
  methods: {
    async requestContent() {
      const res = await this.$http.post('cg/commonRequest', {
        method: 'pinfo.trend.detail',
        // method: 'content.trend.detail',
        token: '',
        trendid: this.$route.params.id,
        terminal: 4,
        label: ''
      });
      if (res.code === 200) {
        this.title = res.data.title;
        this.htmlBody = res.data.body;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.news-content-wrapper {
  font-size: 0.24rem;
  .title {
    text-align: center;
    font-size: 0.26rem;
    line-height: 2;
    color: #666;
    // margin-bottom: 0.3rem;
    margin: 0.4rem 0.34rem 0.3rem;
  }
}
</style>
<style lang="less">
.htmlbody {
  text-align: center;
  img {
    width: 80% !important;
  }
}
</style>
